import * as rule from '@/libs/rules'
import * as time from '@/libs/time'

export default {
  data: () => ({
    /**
     * フォームの入力ルールタイプ
     */
    rule
  }),

  filters: {
    /**
     * 数値をカンマ区切りにする
     *
     * @param {Number|String} n 値
     * @returns {String} カンマ区切りの数字文字列を返す
     */
    comma (n) {
      if (n === undefined || n === null) {
        return ''
      }
      return ((n || 0) - 0).toLocaleString()
    },

    /**
     * 日時情報をフォーマットする
     *
     * @param {String|Number|Date} tm 日時情報
     * @param {String} fmt フォーマット文字列
     * @returns {String} フォーマットされた日時文字列を返す
     */
    timeformat (tm, fmt) {
      return time.format(fmt, tm)
    },

    /**
     * オブジェクトを JSON 形式にする
     *
     * @param {*} x 値
     * @returns {String} JSON形式の文字列
     */
    json (x) {
      return JSON.stringify(x, null, 2)
    }
  }
}
